import { LESS_768_MEDIA_QUERY, LESS_512_MEDIA_QUERY } from '../../../../../consts/adaptive';

const font = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontStyle: 'normal',
};

const defaultMaxVisibleTextLine = 8;

export const styles = {
    title: {
        margin: 0,
        marginBottom: 16,
        fontSize: '20px',
        ...font,
        fontWeight: 700,
        lineHeight: '27px',
        color: '#313140',
    },
    subtitle: {
        display: 'inline-block',
        width: '100%',
        marginTop: 13,
        ...font,
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '21px',
        color: '#000000',

        [`&:last-child`]: {
            marginTop: 22,
        },
    },
    reviewText: {
        position: 'relative',
        margin: 0,
        paddingRight: 15,
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        display: '-webkit-box',
        overflow: 'hidden',
        ...font,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '150%',
        color: 'black',
        borderLeft: '2px solid #f6f6f6',
        [`-webkit-box-orient`]: 'vertical',
        [`-webkit-line-clamp`]: defaultMaxVisibleTextLine,
    },
    paragraph: {
        whiteSpace: 'pre-line',
        textIndent: '1.5rem'
    },
    reviewTextDetail: {
        [`-webkit-line-clamp`]: 'inherit',
    },
    moreInfoButton: {
        position: 'relative',
        padding: '10px 0 19px',
        margin: 0,
        fontFamily: 'Open Sans, Arial, sans-serif',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '10px',
        lineHeight: '14px',
        textTransform: 'uppercase',
        color: '#3d95fb',
        border: 'none',
        background: 'none',
        borderLeft: '2px solid #f6f6f6',
        cursor: 'pointer',

        ['&:hover']: {
            color: '#2087ff',
        },
    },
    emptyReviewContainer: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    emptyParagraph: {
        color: '#9B9B9B'
    },
    [LESS_768_MEDIA_QUERY]: {
        moreInfoButton: {
            marginBottom: 0,
        },
    },
    [LESS_512_MEDIA_QUERY]: {
        reviewText: {
            fontSize: '12px',
        },
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
